import * as React from 'react';

interface TextProps {
    value: {
        text: string
    },
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void,
    onSubmit: () => void
}

export const FilterText: React.SFC<TextProps> = ({value, onChange, onSubmit, onKeyPress}) => {
    return (
        <div className="search__search-form">
            <input type="text" name="search" className="search__search-form__text-field" value={value.text || ''} onKeyPress={onKeyPress} onChange={onChange} placeholder="Enter Keywords..." />
            <button className="search__search-form__submit" onClick={onSubmit}></button>
            <svg className="search__search-form__button-image" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
                <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="search-icon" transform="translate(-2.000000, -2.000000)" fill-rule="nonzero">
                        <circle id="Oval-1" stroke="#F2F2F2" cx="18" cy="18" r="15"></circle>
                        <circle id="Oval-2" stroke="#595959" stroke-width="2" cx="16.5" cy="16.5" r="5.5"></circle>
                        <path d="M20.7551191,20.7551191 L25.1920166,25.1920166 L20.7551191,20.7551191 Z" id="Line-1" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </g>
                </g>
            </svg>
        </div>
    )
}